// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: common/model/PagingPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "io.teamsillim.fightbracket.idl.common.model";

/** paging 요청 패킷 */
export interface PagingRequestPayload {
  /** skip row index */
  skip: number;
  /** read row count (max = 500) */
  take: number;
}

/** paging 응답 패킷 */
export interface PagingResponsePayload {
  /** 총 갯수 */
  totalCount: number;
  /** 데이터 잔여 여부 */
  isRemain: boolean;
}

function createBasePagingRequestPayload(): PagingRequestPayload {
  return { skip: 0, take: 0 };
}

export const PagingRequestPayload: MessageFns<PagingRequestPayload> = {
  encode(message: PagingRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.skip !== 0) {
      writer.uint32(8).int32(message.skip);
    }
    if (message.take !== 0) {
      writer.uint32(16).int32(message.take);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PagingRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePagingRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.skip = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.take = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PagingRequestPayload {
    return {
      skip: isSet(object.skip) ? globalThis.Number(object.skip) : 0,
      take: isSet(object.take) ? globalThis.Number(object.take) : 0,
    };
  },

  toJSON(message: PagingRequestPayload): unknown {
    const obj: any = {};
    if (message.skip !== 0) {
      obj.skip = Math.round(message.skip);
    }
    if (message.take !== 0) {
      obj.take = Math.round(message.take);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PagingRequestPayload>, I>>(base?: I): PagingRequestPayload {
    return PagingRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PagingRequestPayload>, I>>(object: I): PagingRequestPayload {
    const message = createBasePagingRequestPayload();
    message.skip = object.skip ?? 0;
    message.take = object.take ?? 0;
    return message;
  },
};

function createBasePagingResponsePayload(): PagingResponsePayload {
  return { totalCount: 0, isRemain: false };
}

export const PagingResponsePayload: MessageFns<PagingResponsePayload> = {
  encode(message: PagingResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.totalCount !== 0) {
      writer.uint32(8).int32(message.totalCount);
    }
    if (message.isRemain !== false) {
      writer.uint32(16).bool(message.isRemain);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PagingResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePagingResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.totalCount = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.isRemain = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PagingResponsePayload {
    return {
      totalCount: isSet(object.totalCount) ? globalThis.Number(object.totalCount) : 0,
      isRemain: isSet(object.isRemain) ? globalThis.Boolean(object.isRemain) : false,
    };
  },

  toJSON(message: PagingResponsePayload): unknown {
    const obj: any = {};
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    if (message.isRemain !== false) {
      obj.isRemain = message.isRemain;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PagingResponsePayload>, I>>(base?: I): PagingResponsePayload {
    return PagingResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PagingResponsePayload>, I>>(object: I): PagingResponsePayload {
    const message = createBasePagingResponsePayload();
    message.totalCount = object.totalCount ?? 0;
    message.isRemain = object.isRemain ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
